module.exports = __webpack_public_path__ + "img/formaat-white.564f91ed.svg";